import { Typography } from '@mui/material'
import Box from '@mui/material/Box'

export default function Info() {
  return (
    <Box sx={{ p: 2, pt: 1.5 }}>
      <Typography variant='h6'>Standaard voor elke simulatie</Typography>
      <Typography variant='body1'>
        • profiel elektriciteitsvraag (indien meer assets dan laadpalen en warmtepomp, dwz voor assets die we niet
        controleren)
      </Typography>
      <Typography variant='body1'>• profiel zonne-instraling</Typography>
      <Typography variant='body1'>• profiel elektriciteitsprijs</Typography>
      <br />
      <Typography variant='h6'>Bijkomend indien warmte</Typography>
      <Typography variant='body1'>• profiel warmtevraag</Typography>
      <Typography variant='body1'>• Indien variabele warmtebronnen: profiel van warmteaanbod</Typography>
      <Typography variant='body1'>
        • Indien warmtepomp op basis van buffer: profiel van input debiet naar buffer
      </Typography>
      <br />
      <Typography variant='h6'>Bijkomend indien EV</Typography>
      <Typography variant='body1'>
        • profiel voor arrival times, duration times and total energy charged van laadsessies (input voor machine
        learning model van Imec:{' '}
        <a href='http://users.atlantis.ugent.be/cdvelder/papers/2020/lahariya2020energies.pdf'>
          http://users.atlantis.ugent.be/cdvelder/papers/2020/lahariya2020energies.pdf
        </a>{' '}
        and <a href='https://github.com/mlahariya/EV-SDG'>https://github.com/mlahariya/EV-SDG</a>)
      </Typography>
      <br />
      <Typography variant='h6'>Projectspecifieke parameters</Typography>
      <Typography variant='body1'>• parameter range voor batterij (capaciteit, max op/ontlaadvermogen…)</Typography>
      <Typography variant='body1'>
        • parameter range voor PV installatie (oriëntatie, inclinatie, type zonnepanelen, aantal panelen…)
      </Typography>
      <Typography variant='body1'>
        • parameter range voor warmtepomp (capaciteit, compressietrappen, COP-waarden…)
      </Typography>
      <Typography variant='body1'>
        • Indien warmtepomp op basis van buffer: parameter range voor buffer ((max/min)volume, max/min debieten…)
      </Typography>
      <Typography variant='body1'>• Inschatting investeringskost voor assets (bvb battery of PV per kWh...)</Typography>
      <br />
      <Typography variant='h6'>Output</Typography>
      <Typography variant='body1'>• CAPEX en OPEX</Typography>
      <Typography variant='body1'>
        • Percentages eigen verbruik en zelf-voorzienendheid (opgesplitst per energiebron, voor elektriciteit en warmte)
      </Typography>
    </Box>
  )
}
